import * as React from 'react';

import { Pressable, View } from '@/core';
import styles from './style';
import { DeskType } from '../../model';

interface Props {
	desk: DeskType;
	end: string;
	onDeskSelect: (id: number) => void;
	renderReservation: (start: string, end: string, checkoutAt: string, type: string, key: string) => React.ReactNode;
	selectedDesk: number;
	start: string;
}

export const DeskSlots: React.FC<Props> = ({ desk, end, onDeskSelect, renderReservation, selectedDesk, start }) => {
	return (
		<Pressable key={`slot-${desk.id}`} onPress={() => onDeskSelect(desk.id)}>
			<View style={[styles.slots, { opacity: !selectedDesk || selectedDesk === desk.id ? 1 : 0.5 }]}>
				{!!desk.reservations &&
					// Loop through the current desk's reservations (if any) and render a 'blocked' reservation before rendering
					//  the timeslot columns, so that it displays behind the time slot columns and marks these columns in
					//  a color to inform the user these slots are reserved already
					desk.reservations.map((reservation) => {
						return renderReservation(
							reservation.startAt,
							reservation.endAt,
							reservation.checkoutAt,
							'blocked',
							`reservation-${desk.id}-${reservation.startAt}-${reservation.endAt}`,
						);
					})}
				<View style={styles.column}>
					<View style={styles.slot}></View>
				</View>
				{Array.from({ length: 26 }).map((_i, index) => (
					<View style={[styles.column, index % 2 === 0 && styles.wholeHour]} key={`slot_${index.toString()}`}>
						<View style={styles.slot}></View>
					</View>
				))}
				<View style={styles.column}>
					<View style={styles.slot}></View>
				</View>
				{
					// Render the user's prefered time slot
					renderReservation(start, end, null, 'own', `reservation-${desk.id}-${start}-${end}`)
				}
			</View>
		</Pressable>
	);
};
